import { Action } from "redux"

import * as actions from "./actions"
import { INavigation } from "./index"

export const initialState: INavigation = {
    selectedTab: 0,
    workspaces: {
        filter: "",
        pageSize: 25,
        workspaces: [],
        offset: 0,
        hasMore: true,
        isLoading: true,
    },
    smartlists: {
        filter: "",
        pageSize: 25,
        Private: {
            smartlists: [],
            offset: 0,
            hasMore: true,
            isLoading: true,
        },
        SharedByMe: {
            smartlists: [],
            offset: 0,
            hasMore: true,
            isLoading: true,
        },
        SharedWithMe: {
            smartlists: [],
            offset: 0,
            hasMore: true,
            isLoading: true,
        },
    },
}

const handlers: {
    [action: string]: (state: INavigation, props: Action) => INavigation
} = {
    [actions.SET_INITIALIZED]: (state): INavigation => ({
        ...state,
        initialized: true,
    }),

    [actions.RECEIVE_WORKSPACES]: (
        state,
        { workspaces, offset, hasMore }: actions.ReceiveWorkspacesAny,
    ): INavigation => ({
        ...state,
        workspaces: {
            ...state.workspaces,
            workspaces: state.workspaces.workspaces.concat(...workspaces),
            offset,
            isLoading: false,
            hasMore,
        },
    }),

    [actions.FILTER_WORKSPACES]: (
        state,
        { filter }: actions.FilterWorkspacesAny,
    ): INavigation => ({
        ...state,
        workspaces: {
            ...initialState.workspaces,
            filter,
            isLoading: true,
        },
    }),

    [actions.FILTER_SMARTLISTS]: (
        state,
        { filter }: actions.FilterSmartlists,
    ): INavigation => ({
        ...state,
        smartlists: {
            ...state.smartlists,
            filter,
            Private: {
                ...state.smartlists.Private,
                isLoading: true,
                hasMore: true,
            },
            SharedByMe: {
                ...state.smartlists.SharedByMe,
                isLoading: true,
                hasMore: true,
            },
            SharedWithMe: {
                ...state.smartlists.SharedWithMe,
                isLoading: true,
                hasMore: true,
            },
        },
    }),

    [actions.REQUEST_SMARTLISTS]: (state): INavigation => ({
        ...state,
        smartlists: {
            ...initialState.smartlists,
            filter: state.smartlists.filter,
        },
    }),

    [actions.REQUEST_SMARTLISTS_PRIVATE]: (state): INavigation => ({
        ...state,
        smartlists: {
            ...state.smartlists,
            Private: {
                ...state.smartlists.Private,
                isLoading: true,
            },
        },
    }),

    [actions.RECEIVE_SMARTLISTS_PRIVATE]: (
        state,
        { smartlists, offset, hasMore }: actions.ReceiveSmartlistsGeneric,
    ): INavigation => ({
        ...state,
        smartlists: {
            ...state.smartlists,
            Private: {
                ...state.smartlists.Private,
                smartlists: [
                    ...state.smartlists.Private.smartlists,
                    ...smartlists,
                ],
                offset,
                hasMore,
                isLoading: false,
            },
        },
    }),

    [actions.REQUEST_SMARTLISTS_SHARED_BY_ME]: (state): INavigation => ({
        ...state,
        smartlists: {
            ...state.smartlists,
            SharedByMe: {
                ...state.smartlists.SharedByMe,
                isLoading: true,
            },
        },
    }),

    [actions.RECEIVE_SMARTLISTS_SHARED_BY_ME]: (
        state,
        { smartlists, offset, hasMore }: actions.ReceiveSmartlistsGeneric,
    ): INavigation => ({
        ...state,
        smartlists: {
            ...state.smartlists,
            SharedByMe: {
                ...state.smartlists.SharedByMe,
                smartlists: [
                    ...state.smartlists.SharedByMe.smartlists,
                    ...smartlists,
                ],
                offset,
                hasMore,
                isLoading: false,
            },
        },
    }),

    [actions.REQUEST_SMARTLISTS_SHARED_WITH_ME]: (state): INavigation => ({
        ...state,
        smartlists: {
            ...state.smartlists,
            SharedWithMe: {
                ...state.smartlists.SharedWithMe,
                isLoading: true,
            },
        },
    }),

    [actions.RECEIVE_SMARTLISTS_SHARED_WITH_ME]: (
        state,
        { smartlists, offset, hasMore }: actions.ReceiveSmartlistsGeneric,
    ): INavigation => ({
        ...state,
        smartlists: {
            ...state.smartlists,
            SharedWithMe: {
                ...state.smartlists.Private,
                smartlists: [
                    ...state.smartlists.SharedWithMe.smartlists,
                    ...smartlists,
                ],
                offset,
                hasMore,
                isLoading: false,
            },
        },
    }),

    [actions.UPDATE_SELECTED_TAB]: (
        state,
        { tab }: actions.TabAction,
    ): INavigation => ({ ...state, selectedTab: tab }),
}

export default function reducer(
    state: INavigation = initialState,
    action: Action,
): INavigation {
    const handler: (state: INavigation, action: Action) => INavigation =
        handlers[action.type]
    return handler ? handler(state, action) : state
}
